import React from 'react';
import {BadgeCheck} from 'lucide-react';
import {HoverTip} from './HoverTip';
import {useLang} from './i18n';
export function UserVerifiedMark({person}:{person:any}){
 const [,,tr]=useLang();
 if(person?.bot||person?.username?.startsWith('deleted_')||!person?.accountVerified)return null;
 const label=tr('Verified by MALVO','Von MALVO verifiziert');
 return <HoverTip className="user-verified-mark" label={label}><BadgeCheck size={17} aria-hidden="true"/></HoverTip>;
}
